<template>
  <div id="app">
    <router-view></router-view>
    <CheckSystemUpdate />
  </div>
</template>

<script>
  import CheckSystemUpdate from '@/components/CheckSystemUpdate'
  export default {
    name: 'App',
    components: {
      CheckSystemUpdate,
    },
  }
</script>
